/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PreferenceRule,
    PreferenceRuleFromJSON,
    PreferenceRuleToJSON,
    PreferenceRuleConfiguration,
    PreferenceRuleConfigurationFromJSON,
    PreferenceRuleConfigurationToJSON,
    PreferenceRuleListBusinessDataResponse,
    PreferenceRuleListBusinessDataResponseFromJSON,
    PreferenceRuleListBusinessDataResponseToJSON,
    ValidationErrors,
    ValidationErrorsFromJSON,
    ValidationErrorsToJSON,
} from '../models';

export interface ApiPreferenceRuleCreatePreferenceRulePostRequest {
    preferenceRule?: PreferenceRule;
}

export interface ApiPreferenceRuleGetAllPreferenceRulesGetRequest {
    pageNumber?: number;
    pageSize?: number;
}

export interface ApiPreferenceRuleGetByRuleIdRuleIdGetRequest {
    ruleId: string;
}

export interface ApiPreferenceRuleIdDeleteRequest {
    id: string;
}

export interface ApiPreferenceRulePatchRequest {
    preferenceRule?: PreferenceRule;
}

export interface ApiPreferenceRuleValidatePreferenceRulePostRequest {
    preferenceRule?: PreferenceRule;
}

/**
 * no description
 */
export class PreferenceRuleApi extends runtime.BaseAPI {

    /**
     */
    async apiPreferenceRuleCreatePreferenceRulePostRaw(requestParameters: ApiPreferenceRuleCreatePreferenceRulePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/CreatePreferenceRule`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferenceRuleToJSON(requestParameters.preferenceRule),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiPreferenceRuleCreatePreferenceRulePost(requestParameters: ApiPreferenceRuleCreatePreferenceRulePostRequest): Promise<string> {
        const response = await this.apiPreferenceRuleCreatePreferenceRulePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiPreferenceRuleGetAllPreferenceRulesGetRaw(requestParameters: ApiPreferenceRuleGetAllPreferenceRulesGetRequest): Promise<runtime.ApiResponse<PreferenceRuleListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/GetAllPreferenceRules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferenceRuleListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPreferenceRuleGetAllPreferenceRulesGet(requestParameters: ApiPreferenceRuleGetAllPreferenceRulesGetRequest): Promise<PreferenceRuleListBusinessDataResponse> {
        const response = await this.apiPreferenceRuleGetAllPreferenceRulesGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiPreferenceRuleGetByRuleIdRuleIdGetRaw(requestParameters: ApiPreferenceRuleGetByRuleIdRuleIdGetRequest): Promise<runtime.ApiResponse<PreferenceRuleListBusinessDataResponse>> {
        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
            throw new runtime.RequiredError('ruleId','Required parameter requestParameters.ruleId was null or undefined when calling apiPreferenceRuleGetByRuleIdRuleIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/GetByRuleId/{ruleId}`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters.ruleId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferenceRuleListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiPreferenceRuleGetByRuleIdRuleIdGet(requestParameters: ApiPreferenceRuleGetByRuleIdRuleIdGetRequest): Promise<PreferenceRuleListBusinessDataResponse> {
        const response = await this.apiPreferenceRuleGetByRuleIdRuleIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiPreferenceRuleGetConfigurationGetRaw(): Promise<runtime.ApiResponse<PreferenceRuleConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/GetConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferenceRuleConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiPreferenceRuleGetConfigurationGet(): Promise<PreferenceRuleConfiguration> {
        const response = await this.apiPreferenceRuleGetConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiPreferenceRuleIdDeleteRaw(requestParameters: ApiPreferenceRuleIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiPreferenceRuleIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPreferenceRuleIdDelete(requestParameters: ApiPreferenceRuleIdDeleteRequest): Promise<void> {
        await this.apiPreferenceRuleIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiPreferenceRulePatchRaw(requestParameters: ApiPreferenceRulePatchRequest): Promise<runtime.ApiResponse<number>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PreferenceRuleToJSON(requestParameters.preferenceRule),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiPreferenceRulePatch(requestParameters: ApiPreferenceRulePatchRequest): Promise<number> {
        const response = await this.apiPreferenceRulePatchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiPreferenceRuleValidatePreferenceRulePostRaw(requestParameters: ApiPreferenceRuleValidatePreferenceRulePostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/PreferenceRule/ValidatePreferenceRule`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferenceRuleToJSON(requestParameters.preferenceRule),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiPreferenceRuleValidatePreferenceRulePost(requestParameters: ApiPreferenceRuleValidatePreferenceRulePostRequest): Promise<ValidationErrors> {
        const response = await this.apiPreferenceRuleValidatePreferenceRulePostRaw(requestParameters);
        return await response.value();
    }

}
